module.exports = __webpack_public_path__ + "static/img/checksy.1d51a52.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/checksy.png
// module id = n8XT
// module chunks = 1